import * as z from 'zod';
import { MenuItemVisibility, MenuLinkItem } from 'models/layout';
import * as routes from 'router/routes';
import defaultTranslation from 'assets/languages/en.json';

// Language
export type AppTranslation = typeof defaultTranslation;
export type Translation = {
  languageCode: string;
  languageRegionCode?: string;
  language: AppTranslation;
};

export const defaultLanguageCode = 'en';
export const defaultCountryCode = 'GB';
export const supportedNorwegianLangCode = 'nb';
export const unSupportedNorwegianLangCodes = ['no', 'nn'];
export const supportedRegionalLangCodes = ['pt-BR'];

// Links
export const supportUrlHusqvarna = 'https://www.husqvarna.com/support/';
export const supportUrlConstruction =
  'https://www.husqvarnaconstruction.com/int/support/';
export const privacyPolicyUrlHusqvarna = 'https://www.husqvarna.com/privacy/';
export const privacyPolicyUrlConstruction = 'https://husqvarna.com/privacy/';
export const howToFindProductInfoUrl =
  'https://www.husqvarna.com/support/husqvarna-self-service/ka-01030/';

// Zod schemas
export const noSpecialCharsSchema = z
  .string()
  .transform((val) => val.replace(/[^a-zA-Z0-9]/g, ''));

// Other
export const enum ContractTypes {
  TermsOfUse = 'TERMS_AND_CONDITIONS'
}
export const mavenoidMainProductId = 9595839;

export const diamUserIdStorageKey = 'diamUserId';

// Brands
export const supportedBrands = ['husqvarna', 'construction'];

// Menus

export const menuLinks: MenuLinkItem[] = [
  {
    name: 'menu.my_products',
    link: routes.PRODUCTS,
    visibility: MenuItemVisibility.Private
  },
  {
    name: 'menu.my_services',
    link: routes.SERVICES,
    visibility: MenuItemVisibility.Private
  },
  {
    name: 'menu.my_profile',
    link: routes.PROFILE,
    visibility: MenuItemVisibility.Private
  },
  {
    name: 'menu.login',
    link: routes.LOGIN,
    visibility: MenuItemVisibility.Public
  },
  {
    name: 'menu.signup',
    link: routes.SIGNUP,
    visibility: MenuItemVisibility.Public
  },
  {
    name: 'menu.product_registration',
    link: routes.PRODUCT_REG,
    visibility: MenuItemVisibility.Hybrid
  }
];

export const externalMenuLinksHusqvarna = [
  {
    link: 'https://husqvarna.com',
    name: 'menu.husqvarna'
  },
  {
    link: supportUrlHusqvarna,
    name: 'menu.contact_support'
  }
];

export const externalMenuLinksConstruction = [
  {
    link: 'https://www.husqvarnaconstruction.com/',
    name: 'menu.construction'
  },
  {
    link: supportUrlConstruction,
    name: 'menu.contact_support'
  }
];

export const footerLinksHusqvarna = [
  {
    link: privacyPolicyUrlHusqvarna,
    type: 'external',
    name: 'menu.privacy'
  },
  {
    link: routes.TERMS_OF_USE,
    type: 'external',
    name: 'menu.terms'
  },
  {
    link: 'https://www.husqvarna.com/cookies/',
    type: 'external',
    name: 'menu.cookies'
  },
  {
    link: 'https://www.husqvarna.com/imprint/',
    type: 'external',
    name: 'menu.imprint'
  },
  {
    link: supportUrlHusqvarna,
    type: 'external',
    name: 'menu.support'
  }
];

export const footerLinksConstruction = [
  {
    link: privacyPolicyUrlConstruction,
    type: 'external',
    name: 'menu.privacy'
  },
  {
    link: routes.TERMS_OF_USE,
    type: 'external',
    name: 'menu.terms'
  },
  {
    link: 'https://www.husqvarnaconstruction.com/int/cookie-policy',
    type: 'external',
    name: 'menu.cookies'
  },
  {
    link: 'https://www.husqvarnaconstruction.com/int/imprint/',
    type: 'external',
    name: 'menu.imprint'
  },
  {
    link: supportUrlConstruction,
    type: 'external',
    name: 'menu.support'
  }
];
